import { render, staticRenderFns } from "./CorrespondentCover.vue?vue&type=template&id=268ca29a"
import script from "./CorrespondentCover.vue?vue&type=script&lang=js"
export * from "./CorrespondentCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports